export const PAGES = [
	"INTRO",
	"ABOUT",
	"CONTACT",
	"SERVICES"
];


export const WORK = {
	"wat": {
		"title": "WAT IS THIS",
		"slides": [
			{
				"image": require('./assets/images/_portfolio/01.jpg'),
				"job": "Teaser Site",
				"title": "Ready Player One",
				"role": [
					"Web & Mobile Development",
					"Animation"
				],
				"timeline": "4 Days",
				"linkout": "http://google.com"

			 },
			{
				"image": require('./assets/images/_portfolio/02.jpg'),
				"job": "Teaser Site",
				"title": "Ready Player One",
				"role": [
					"Web & Mobile Development",
					"Animation"
				],
				"timeline": "4 Days",
				"linkout": "http://google.com"

			 },
			{
				"image": require('./assets/images/_portfolio/03.jpg'),
				"job": "Teaser Site",
				"title": "Ready Player One",
				"role": [
					"Web & Mobile Development",
					"Animation"
				],
				"timeline": "4 Days",
				"linkout": "http://google.com"

			 },
			{
				"image": require('./assets/images/_portfolio/04.jpg'),
				"job": "Teaser Site",
				"title": "Ready Player One",
				"role": [
					"Web & Mobile Development",
					"Animation"
				],
				"timeline": "4 Days",
				"linkout": "http://google.com"

			 }
		]
	}
}


// WEBPACK FOOTER //
// ./src/react.constants.js